import { useEffect, useRef } from "react";

import { useLogout } from "@/authentication/useLogout";

export function LogoutPage(): null {
  const logout = useLogout();
  const alreadyLoggingOut = useRef(false);

  useEffect(() => {
    if (alreadyLoggingOut.current) {
      return;
    }

    alreadyLoggingOut.current = true;

    void logout();
  }, [logout]);

  return null;
}
